module.exports = __webpack_public_path__ + "static/media/garbage.45e96328.svg";